// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageUploadForm_imageSection__M0i3M","imageWrapper":"ImageUploadForm_imageWrapper__cpEgc","error":"ImageUploadForm_error__q+qWk"};